"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeInterface = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../../../../editor/theme");
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../../Colors");
const index_1 = require("../../../icons/index");
const NodeInterfaceBlock = typestyle_1.style({
    padding: `3px 6px`,
    background: theme_1.GraphQLBackgrounds.interface,
    color: Colors_1.Colors.grey[1],
    fontSize: 10,
    borderRadius: 4,
    marginLeft: 10,
    position: 'relative',
    cursor: 'pointer',
    marginBottom: 5,
    $nest: {
        '.DeleteInterface': {
            opacity: 0.0,
            position: 'absolute',
            pointerEvents: 'none',
            cursor: 'pointer',
            top: -17,
            right: 0,
            fontSize: 8,
            width: 200,
            textAlign: 'right',
            $nest: {
                svg: {
                    fill: 'red',
                },
                '&:hover': {
                    opacity: 1.0,
                },
            },
        },
        svg: {
            display: 'none',
            marginLeft: 5,
            fill: Colors_1.Colors.red[0],
        },
        '&:hover': {
            $nest: {
                '.DeleteInterface': {
                    opacity: 1.0,
                },
                svg: {
                    display: 'inline',
                },
            },
        },
    },
});
exports.NodeInterface = ({ onDelete, children, isLocked }) => {
    return (react_1.default.createElement("div", { className: NodeInterfaceBlock, onClick: (e) => {
            if (isLocked) {
                return;
            }
            e.stopPropagation();
            onDelete();
        } },
        !isLocked && react_1.default.createElement("div", { className: 'DeleteInterface' }, "Click to delete"),
        react_1.default.createElement("span", null,
            children,
            !isLocked && react_1.default.createElement(index_1.X, { fill: Colors_1.Colors.red[0] }))));
};
